export var TracesSubject;
(function (TracesSubject) {
    TracesSubject["operationName"] = "operationName";
    TracesSubject["traceWaterfallTable"] = "traceWaterfallTable";
    // Still used by the legacy app-frontend trace table (K360TracesTable) pending its migration.
    TracesSubject["k360TracesTable"] = "k360TracesTable";
})(TracesSubject || (TracesSubject = {}));
//# sourceMappingURL=traces.enum.js.map